import { ShowMore } from "@/molecules/ShowMore"

import type { MoreTableCellComponent } from "."

export const MoreTableCell: MoreTableCellComponent = ({
  count,
  label: labelText,
  id,
  linkItems,
  ...props
}) => {
  const text = count === undefined
  const copyable = props.copyable || !!props.copyableTitle
  const LabelComponent = text ? ShowMore.Label.Text : ShowMore.Label.Count
  const label = (
    <LabelComponent copyable={copyable} count={count || 0}>
      {labelText}
    </LabelComponent>
  )

  // A popover stays open for its items to be copied or to open their drawers
  if (copyable || linkItems)
    return (
      <ShowMore.Popover {...props}>
        <span>{label}</span>
      </ShowMore.Popover>
    )

  return (
    <ShowMore id={id} label={label}>
      <ShowMore.Tooltip {...props} />
    </ShowMore>
  )
}
